import { Component } from '@angular/core';
import { ElementBase } from "../element-base";

@Component({
  selector: 'app-element-time',
  templateUrl: './element-time.component.html',
  styleUrl: './element-time.component.scss'
})
export class ElementTimeComponent extends ElementBase {

}
